import type {
  IconEnum as AuiIconEnum,
  IconProps,
} from "@avinet/adaptive-ui-core/ui/Icon";
import AuiIcon from "@avinet/adaptive-ui-core/ui/Icon";
import type { icons } from "../style/icons";

export type IconEnum = keyof typeof icons | AuiIconEnum;

export function Icon(props: IconProps & { name: IconEnum }) {
  return <AuiIcon {...props} />;
}
